import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchBrands = createAsyncThunk("brands/fetchBrands", async () => {
  const { data } = await api.get("/brands");
  return data;
});

export const fetchBrandBySlug = createAsyncThunk(
  "brands/fetchBrandBySlug",
  async (slug) => {
    const { data } = await api.get(`/brands/${slug}`);
    return data;
  },
);

const brandsSlice = createSlice({
  name: "brands",
  initialState: {
    items: [],
    current: null,
    currentLoading: false,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentBrand: (state) => {
      state.current = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.brands;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchBrandBySlug.pending, (state) => {
        state.currentLoading = true;
        state.error = null;
      })
      .addCase(fetchBrandBySlug.fulfilled, (state, action) => {
        state.currentLoading = false;
        state.current = action.payload;
      })
      .addCase(fetchBrandBySlug.rejected, (state, action) => {
        state.currentLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearCurrentBrand } = brandsSlice.actions;
export default brandsSlice.reducer;
